import { AnimatePresence, motion } from 'framer-motion'
import { useEffect, useState } from 'react'

import { motionFadeIn } from '@apps-common/config/motion-variants'
import { IUnitCreateMultipleDefaultsModel } from '@apps-common/types/management/unit'

import { UnitAddProcessing, UnitDefaultsForm } from './initial-config'

enum UnitCreateMultipleSteps {
  unitDefaults = 'unitDefaults',
  processing = 'processing'
}

export const UnitCreateMultipleView = () => {
  const [step, setStep] = useState<UnitCreateMultipleSteps>(UnitCreateMultipleSteps.unitDefaults)
  const [unitDefaults, setUnitDefaults] = useState<IUnitCreateMultipleDefaultsModel>()

  const restart = () => {
    setUnitDefaults(undefined)
  }

  const moveStep = () => {
    if (!unitDefaults) {
      setStep(UnitCreateMultipleSteps.unitDefaults)
    }

    if (step === UnitCreateMultipleSteps.unitDefaults && unitDefaults) {
      setStep(UnitCreateMultipleSteps.processing)
    }
  }

  useEffect(() => {
    moveStep()
  }, [unitDefaults])

  return (
    <div>
      <AnimatePresence mode='wait'>
        {step === UnitCreateMultipleSteps.unitDefaults && (
          <motion.div key='unit-create-multiple-step-unit-defaults' {...motionFadeIn(0.25)}>
            <UnitDefaultsForm defaults={unitDefaults} doneCallback={(values) => setUnitDefaults(values)} />
          </motion.div>
        )}
        {step === UnitCreateMultipleSteps.processing && (
          <motion.div key='unit-create-multiple-step-processing' {...motionFadeIn(0.25)}>
            <UnitAddProcessing unitDefaults={unitDefaults!} restart={restart} />
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  )
}
